package com.anjuros.website.redesign.sections.home

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdGhostButton
import com.anjuros.website.redesign.components.RdLede
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdPrimaryButton
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.styles.HomeHeroTitleStyle
import com.anjuros.website.redesign.styles.HomeMosaicCaptionStyle
import com.anjuros.website.redesign.styles.HomeMosaicStyle
import com.anjuros.website.redesign.styles.HomeMosaicTileStyle
import com.anjuros.website.redesign.styles.HomePortalNoteLinkStyle
import com.anjuros.website.redesign.styles.HomePortalNoteStyle
import com.anjuros.website.redesign.styles.RdButtonRowStyle
import com.anjuros.website.redesign.styles.RdFactsStyle
import com.anjuros.website.redesign.styles.RdHeroCopyStyle
import com.anjuros.website.redesign.styles.RdHeroGridStyle
import com.anjuros.website.redesign.styles.RdHeroStyle
import com.anjuros.website.redesign.styles.RdMarkStyle
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

private val MosaicTiles = listOf(
    RdImage.DESIGN_DECORATOR to RdText.TRADE_DECORATORS,
    RdImage.DESIGN_DOG_WALKER to RdText.TRADE_DOG_WALKERS,
    RdImage.DESIGN_ELECTRICIAN to RdText.TRADE_ELECTRICIANS,
    RdImage.DESIGN_HANDYMAN to RdText.TRADE_HANDYMEN,
)

private val Facts = listOf(
    RdText.HOME_FACT1_VALUE to RdText.HOME_FACT1_LABEL,
    RdText.HOME_FACT2_VALUE to RdText.HOME_FACT2_LABEL,
    RdText.HOME_FACT3_VALUE to RdText.HOME_FACT3_LABEL,
)

@Composable
fun HomeHeroSection() {
    RdSection(labelledBy = "h1", modifier = RdHeroStyle.toModifier(), wrapModifier = RdHeroGridStyle.toModifier()) {
        Div(RdHeroCopyStyle.toModifier().toAttrs()) {
            RdEyebrow(RdText.HOME_HERO_EYEBROW)
            H1(HomeHeroTitleStyle.toModifier().id("h1").toAttrs()) {
                Text(LocalText(RdText.HOME_HERO_TITLE_START))
                Span(RdMarkStyle.toModifier().toAttrs()) { Text(LocalText(RdText.HOME_HERO_TITLE_MARK)) }
                Text(LocalText(RdText.HOME_HERO_TITLE_END))
            }
            RdLede(RdText.HOME_HERO_LEDE)
            Div(RdButtonRowStyle.toModifier().toAttrs()) {
                RdPrimaryButton("#designs", RdText.HOME_HERO_SEE_DESIGNS, withArrow = true)
                RdGhostButton("#contact", RdText.CTA_FREE_PREVIEW)
            }
            PortalNote()
            Ul(RdFactsStyle.toModifier().toAttrs()) {
                Facts.forEach { (value, label) ->
                    Li {
                        B { Text(LocalText(value)) }
                        Span { Text(LocalText(label)) }
                    }
                }
            }
        }
        Mosaic()
    }
}

@Composable
private fun PortalNote() {
    RdLink("#portal", HomePortalNoteStyle.toModifier()) {
        RdIcons.Dashboard(size = 22)
        Span {
            B { Text(LocalText(RdText.HOME_HERO_PORTAL_BOLD)) }
            Text(LocalText(RdText.HOME_HERO_PORTAL_TEXT))
            Span(HomePortalNoteLinkStyle.toModifier().toAttrs()) { Text(LocalText(RdText.HOME_HERO_PORTAL_LINK)) }
        }
    }
}

/** Four trade designs, so the hero reads as "for every trade" rather than one. */
@Composable
private fun Mosaic() {
    Div(HomeMosaicStyle.toModifier().attrsModifier { attr("aria-hidden", "true") }.toAttrs()) {
        MosaicTiles.forEach { (image, caption) ->
            RdTag("figure", HomeMosaicTileStyle.toModifier()) {
                RdPicture(image, alt = "", lazy = false)
                RdTag("figcaption", HomeMosaicCaptionStyle.toModifier()) { Text(LocalText(caption)) }
            }
        }
    }
}

